import { graphql } from "../__generated__/gql";

export const GET_DEFLATORS_QUERY = graphql(`
  query GetDeflators {
    deflators: year {
      year
      deflator
    }
  }
`);

export default GET_DEFLATORS_QUERY;
